export const dp_app_negative_brightest = 'var(--dp_app_negative_brightest)';
export const dp_app_negative_brighter = 'var(--dp_app_negative_brighter)';
export const dp_app_negative_bright = 'var(--dp_app_negative_bright)';
export const dp_app_negative_mid = 'var(--dp_app_negative_mid)';
export const dp_app_negative_dull = 'var(--dp_app_negative_dull)';
export const dp_app_negative_duller = 'var(--dp_app_negative_duller)';
export const dp_app_negative_dullest = 'var(--dp_app_negative_dullest)';
export const dp_app_warning_brightest = 'var(--dp_app_warning_brightest)';
export const dp_app_warning_brighter = 'var(--dp_app_warning_brighter)';
export const dp_app_warning_bright = 'var(--dp_app_warning_bright)';
export const dp_app_warning_mid = 'var(--dp_app_warning_mid)';
export const dp_app_warning_dull = 'var(--dp_app_warning_dull)';
export const dp_app_warning_duller = 'var(--dp_app_warning_duller)';
export const dp_app_warning_dullest = 'var(--dp_app_warning_dullest)';
export const dp_app_info_brightest = 'var(--dp_app_info_brightest)';
export const dp_app_info_brighter = 'var(--dp_app_info_brighter)';
export const dp_app_info_bright = 'var(--dp_app_info_bright)';
export const dp_app_info_mid = 'var(--dp_app_info_mid)';
export const dp_app_info_dull = 'var(--dp_app_info_dull)';
export const dp_app_info_duller = 'var(--dp_app_info_duller)';
export const dp_app_info_dullest = 'var(--dp_app_info_dullest)';
export const dp_app_positive_brightest = 'var(--dp_app_positive_brightest)';
export const dp_app_positive_brighter = 'var(--dp_app_positive_brighter)';
export const dp_app_positive_bright = 'var(--dp_app_positive_bright)';
export const dp_app_positive_mid = 'var(--dp_app_positive_mid)';
export const dp_app_positive_dull = 'var(--dp_app_positive_dull)';
export const dp_app_positive_duller = 'var(--dp_app_positive_duller)';
export const dp_app_positive_dullest = 'var(--dp_app_positive_dullest)';
export const dp_app_selection_brightest = 'var(--dp_app_selection_brightest)';
export const dp_app_selection_brighter = 'var(--dp_app_selection_brighter)';
export const dp_app_selection_bright = 'var(--dp_app_selection_bright)';
export const dp_app_selection_mid = 'var(--dp_app_selection_mid)';
export const dp_app_selection_dim = 'var(--dp_app_selection_dim)';
export const dp_app_selection_dull = 'var(--dp_app_selection_dull)';
export const dp_app_selection_duller = 'var(--dp_app_selection_duller)';
export const dp_app_selection_dullest = 'var(--dp_app_selection_dullest)';
export const dp_app_text_base = 'var(--dp_app_text_base)';
export const dp_app_text_subtle = 'var(--dp_app_text_subtle)';
export const dp_app_text_subdued = 'var(--dp_app_text_subdued)';
export const dp_app_text_inverted = 'var(--dp_app_text_inverted)';
export const dp_app_text_base_inverted = 'var(--dp_app_text_base_inverted)';
export const dp_app_text_negative = 'var(--dp_app_text_negative)';
export const dp_app_text_warning = 'var(--dp_app_text_warning)';
export const dp_app_text_positive = 'var(--dp_app_text_positive)';
export const dp_app_text_disabled = 'var(--dp_app_text_disabled)';
export const dp_app_text_urgency_medium = 'var(--dp_app_text_urgency_medium)';
export const dp_app_text_urgency_high = 'var(--dp_app_text_urgency_high)';
export const dp_app_link_base = 'var(--dp_app_link_base)';
export const dp_app_link_hover = 'var(--dp_app_link_hover)';
export const dp_app_link_pressed = 'var(--dp_app_link_pressed)';
export const dp_app_link_visited_base = 'var(--dp_app_link_visited_base)';
export const dp_app_link_visited = 'var(--dp_app_link_visited)';
export const dp_app_link_visited_hover = 'var(--dp_app_link_visited_hover)';
export const dp_app_link_visited_pressed = 'var(--dp_app_link_visited_pressed)';
export const dp_app_backdrop_base = 'var(--dp_app_backdrop_base)';
export const dp_app_backdrop_white = 'var(--dp_app_backdrop_white)';
export const dp_app_backdrop_dull = 'var(--dp_app_backdrop_dull)';
export const dp_app_backdrop_base_brightest = 'var(--dp_app_backdrop_base_brightest)';
export const dp_app_backdrop_duller = 'var(--dp_app_backdrop_duller)';
export const dp_app_backdrop_base_brighter = 'var(--dp_app_backdrop_base_brighter)';
export const dp_app_backdrop_one_brightest = 'var(--dp_app_backdrop_one_brightest)';
export const dp_app_backdrop_one_brighter = 'var(--dp_app_backdrop_one_brighter)';
export const dp_app_backdrop_one_duller = 'var(--dp_app_backdrop_one_duller)';
export const dp_app_backdrop_one_dullest = 'var(--dp_app_backdrop_one_dullest)';
export const dp_app_backdrop_two_brightest = 'var(--dp_app_backdrop_two_brightest)';
export const dp_app_backdrop_two_brighter = 'var(--dp_app_backdrop_two_brighter)';
export const dp_app_backdrop_two_duller = 'var(--dp_app_backdrop_two_duller)';
export const dp_app_backdrop_two_dullest = 'var(--dp_app_backdrop_two_dullest)';
export const dp_app_backdrop_three_brightest = 'var(--dp_app_backdrop_three_brightest)';
export const dp_app_backdrop_three_brighter = 'var(--dp_app_backdrop_three_brighter)';
export const dp_app_backdrop_three_duller = 'var(--dp_app_backdrop_three_duller)';
export const dp_app_backdrop_three_dullest = 'var(--dp_app_backdrop_three_dullest)';
export const dp_app_backdrop_four_brightest = 'var(--dp_app_backdrop_four_brightest)';
export const dp_app_backdrop_four_brighter = 'var(--dp_app_backdrop_four_brighter)';
export const dp_app_backdrop_four_duller = 'var(--dp_app_backdrop_four_duller)';
export const dp_app_backdrop_four_dullest = 'var(--dp_app_backdrop_four_dullest)';
export const dp_app_border_base = 'var(--dp_app_border_base)';
export const dp_app_border_bright = 'var(--dp_app_border_bright)';
export const dp_app_border_dull = 'var(--dp_app_border_dull)';
export const dp_app_action_primary = 'var(--dp_app_action_primary)';
export const dp_app_co2_banner_background = 'var(--dp_app_co2_banner_background)';
export const dp_app_co2_banner_background_hover = 'var(--dp_app_co2_banner_background_hover)';
export const dp_app_co2_banner_action_icon_fill = 'var(--dp_app_co2_banner_action_icon_fill)';
export const dp_app_co2_banner_body = 'var(--dp_app_co2_banner_body)';
export const dp_app_action_secondary = 'var(--dp_app_action_secondary)';
export const dp_app_action_tertiary = 'var(--dp_app_action_tertiary)';
export const dp_app_action_destructive = 'var(--dp_app_action_destructive)';
export const dp_app_action_disabled = 'var(--dp_app_action_disabled)';
export const dp_app_focus_ring = 'var(--dp_app_focus_ring)';
export const dp_app_focus_ring_inverted = 'var(--dp_app_focus_ring_inverted)';
export const dp_app_box_shadow = 'var(--dp_app_box_shadow)';
export const dp_app_overlay_backdrop_dim = 'var(--dp_app_overlay_backdrop_dim)';
export const dp_app_overlay_backdrop_dull = 'var(--dp_app_overlay_backdrop_dull)';
export const dp_app_overlay_backdrop_dullest = 'var(--dp_app_overlay_backdrop_dullest)';
export const dp_app_modal_background = 'var(--dp_app_modal_background)';
export const dp_app_button_primary_background = 'var(--dp_app_button_primary_background)';
export const dp_app_button_primary_background_hover =
  'var(--dp_app_button_primary_background_hover)';
export const dp_app_button_primary_background_pressed =
  'var(--dp_app_button_primary_background_pressed)';
export const dp_app_button_secondary_background = 'var(--dp_app_button_secondary_background)';
export const dp_app_button_secondary_background_hover =
  'var(--dp_app_button_secondary_background_hover)';
export const dp_app_button_secondary_background_pressed =
  'var(--dp_app_button_secondary_background_pressed)';
export const dp_app_button_tertiary_background = 'var(--dp_app_button_tertiary_background)';
export const dp_app_button_tertiary_background_hover =
  'var(--dp_app_button_tertiary_background_hover)';
export const dp_app_button_tertiary_background_pressed =
  'var(--dp_app_button_tertiary_background_pressed)';
export const dp_app_button_tertiary_border = 'var(--dp_app_button_tertiary_border)';
export const dp_app_message_info_background = 'var(--dp_app_message_info_background)';
export const dp_app_message_info_left_edge = 'var(--dp_app_message_info_left_edge)';
export const dp_app_message_info_border = 'var(--dp_app_message_info_border)';
export const dp_app_message_positive_background = 'var(--dp_app_message_positive_background)';
export const dp_app_message_positive_left_edge = 'var(--dp_app_message_positive_left_edge)';
export const dp_app_message_positive_border = 'var(--dp_app_message_positive_border)';
export const dp_app_message_warning_background = 'var(--dp_app_message_warning_background)';
export const dp_app_message_warning_left_edge = 'var(--dp_app_message_warning_left_edge)';
export const dp_app_message_warning_border = 'var(--dp_app_message_warning_border)';
export const dp_app_message_negative_background = 'var(--dp_app_message_negative_background)';
export const dp_app_message_negative_left_edge = 'var(--dp_app_message_negative_left_edge)';
export const dp_app_message_negative_border = 'var(--dp_app_message_negative_border)';
export const dp_app_carrier_logo_monochrome_fill = 'var(--dp_app_carrier_logo_monochrome_fill)';
export const dp_app_search_form_background = 'var(--dp_app_search_form_background)';
export const dp_app_text_field_border = 'var(--dp_app_text_field_border)';
export const dp_app_text_field_border_hover = 'var(--dp_app_text_field_border_hover)';
export const dp_app_text_field_border_focus = 'var(--dp_app_text_field_border_focus)';
export const dp_app_text_field_border_invalid = 'var(--dp_app_text_field_border_invalid)';
export const dp_app_text_field_placeholder = 'var(--dp_app_text_field_placeholder)';
export const dp_app_text_subtle_inverted = 'var(--dp_app_text_subtle_inverted)';
export const dp_app_text_subdued_inverted = 'var(--dp_app_text_subdued_inverted)';
export const dp_app_backdrop_black = 'var(--dp_app_backdrop_black)';
export const dp_app_backdrop_base_duller = 'var(--dp_app_backdrop_base_duller)';
export const dp_app_backdrop_base_dullest = 'var(--dp_app_backdrop_base_dullest)';
export const dp_app_backdrop_primary_brightest = 'var(--dp_app_backdrop_primary_brightest)';
export const dp_app_backdrop_primary_brighter = 'var(--dp_app_backdrop_primary_brighter)';
export const dp_app_backdrop_primary_duller = 'var(--dp_app_backdrop_primary_duller)';
export const dp_app_backdrop_primary_dullest = 'var(--dp_app_backdrop_primary_dullest)';
export const dp_app_backdrop_secondary_brightest = 'var(--dp_app_backdrop_secondary_brightest)';
export const dp_app_backdrop_secondary_brighter = 'var(--dp_app_backdrop_secondary_brighter)';
export const dp_app_backdrop_secondary_duller = 'var(--dp_app_backdrop_secondary_duller)';
export const dp_app_backdrop_secondary_dullest = 'var(--dp_app_backdrop_secondary_dullest)';
export const dp_app_backdrop_tertiary_brightest = 'var(--dp_app_backdrop_tertiary_brightest)';
export const dp_app_backdrop_tertiary_brighter = 'var(--dp_app_backdrop_tertiary_brighter)';
export const dp_app_backdrop_tertiary_duller = 'var(--dp_app_backdrop_tertiary_duller)';
export const dp_app_backdrop_tertiary_dullest = 'var(--dp_app_backdrop_tertiary_dullest)';
export const dp_app_button_destructive_background = 'var(--dp_app_button_destructive_background)';
export const dp_app_button_destructive_background_hover =
  'var(--dp_app_button_destructive_background_hover)';
export const dp_app_button_destructive_background_pressed =
  'var(--dp_app_button_destructive_background_pressed)';
export const dp_app_button_promo1_background = 'var(--dp_app_button_promo1_background)';
export const dp_app_button_promo1_background_hover = 'var(--dp_app_button_promo1_background_hover)';
export const dp_app_button_promo1_background_pressed =
  'var(--dp_app_button_promo1_background_pressed)';
export const dp_app_button_promo2_background = 'var(--dp_app_button_promo2_background)';
export const dp_app_button_promo2_background_hover = 'var(--dp_app_button_promo2_background_hover)';
export const dp_app_button_promo2_background_pressed =
  'var(--dp_app_button_promo2_background_pressed)';
export const dp_app_button_transparent_background = 'var(--dp_app_button_transparent_background)';
export const dp_app_button_transparent_background_hover =
  'var(--dp_app_button_transparent_background_hover)';
export const dp_app_button_transparent_background_pressed =
  'var(--dp_app_button_transparent_background_pressed)';
export const dp_app_inline_text_button_label = 'var(--dp_app_inline_text_button_label)';
export const dp_app_inline_text_button_label_inverted =
  'var(--dp_app_inline_text_button_label_inverted)';
export const dp_app_message_primary_background = 'var(--dp_app_message_primary_background)';
export const dp_app_message_primary_border = 'var(--dp_app_message_primary_border)';
export const dp_app_message_secondary_background = 'var(--dp_app_message_secondary_background)';
export const dp_app_message_neutral_background = 'var(--dp_app_message_neutral_background)';
export const dp_app_message_neutral_border = 'var(--dp_app_message_neutral_border)';
export const dp_app_message_action_icon_fill = 'var(--dp_app_message_action_icon_fill)';
export const dp_app_selectable_text = 'var(--dp_app_selectable_text)';
export const dp_app_selectable_background_base = 'var(--dp_app_selectable_background_base)';
export const dp_app_selectable_background_hover = 'var(--dp_app_selectable_background_hover)';
export const dp_app_selectable_background_pressed = 'var(--dp_app_selectable_background_pressed)';
export const dp_app_selectable_disabled_background = 'var(--dp_app_selectable_disabled_background)';
export const dp_app_selectable_border_base = 'var(--dp_app_selectable_border_base)';
export const dp_app_selectable_border_dull = 'var(--dp_app_selectable_border_dull)';
export const dp_app_selectable_border_hover = 'var(--dp_app_selectable_border_hover)';
export const dp_app_selectable_border_pressed = 'var(--dp_app_selectable_border_pressed)';
export const dp_app_selectable_border_invalid = 'var(--dp_app_selectable_border_invalid)';
export const dp_app_selected_text = 'var(--dp_app_selected_text)';
export const dp_app_selected_background_base = 'var(--dp_app_selected_background_base)';
export const dp_app_selected_background_dull = 'var(--dp_app_selected_background_dull)';
export const dp_app_selected_background_hover = 'var(--dp_app_selected_background_hover)';
export const dp_app_selected_background_pressed = 'var(--dp_app_selected_background_pressed)';
export const dp_app_selected_border_base = 'var(--dp_app_selected_border_base)';
export const dp_app_selected_border_hover = 'var(--dp_app_selected_border_hover)';
export const dp_app_selected_border_pressed = 'var(--dp_app_selected_border_pressed)';
export const dp_app_spinner_background_base = 'var(--dp_app_spinner_background_base)';
export const dp_app_spinner_background_inverted = 'var(--dp_app_spinner_background_inverted)';
export const dp_app_text_field_background_base = 'var(--dp_app_text_field_background_base)';
export const dp_app_text_field_background_disabled = 'var(--dp_app_text_field_background_disabled)';
export const dp_app_text_field_label_base = 'var(--dp_app_text_field_label_base)';
export const dp_app_text_field_label_focus = 'var(--dp_app_text_field_label_focus)';
export const dp_app_text_field_icon_fill_base = 'var(--dp_app_text_field_icon_fill_base)';
export const dp_app_text_field_icon_fill_brighter = 'var(--dp_app_text_field_icon_fill_brighter)';
export const dp_app_icon_fill_base = 'var(--dp_app_icon_fill_base)';
export const dp_app_icon_fill_subtle = 'var(--dp_app_icon_fill_subtle)';
export const dp_app_icon_fill_subdued = 'var(--dp_app_icon_fill_subdued)';
export const dp_app_icon_fill_inverted = 'var(--dp_app_icon_fill_inverted)';
export const dp_app_overlay_background_base = 'var(--dp_app_overlay_background_base)';
export const dp_app_overlay_background_inverted = 'var(--dp_app_overlay_background_inverted)';
export const dp_app_tooltip_background = 'var(--dp_app_tooltip_background)';
export const dp_app_snackbar_background = 'var(--dp_app_snackbar_background)';
export const dp_app_bubble_background = 'var(--dp_app_bubble_background)';
export const dp_app_header_background_secondary = 'var(--dp_app_header_background_secondary)';
export const dp_app_text_tlb_brand_primary = 'var(--dp_app_text_tlb_brand_primary)';
export const dp_app_bbt_tag_background = 'var(--dp_app_bbt_tag_background)';
export const dp_brand_primary_core = 'var(--dp_brand_primary_core)';
export const dp_brand_primary_brightest = 'var(--dp_brand_primary_brightest)';
export const dp_brand_primary_brighter = 'var(--dp_brand_primary_brighter)';
export const dp_brand_primary_bright = 'var(--dp_brand_primary_bright)';
export const dp_brand_primary_mid = 'var(--dp_brand_primary_mid)';
export const dp_brand_primary_dim = 'var(--dp_brand_primary_dim)';
export const dp_brand_primary_dull = 'var(--dp_brand_primary_dull)';
export const dp_brand_primary_duller = 'var(--dp_brand_primary_duller)';
export const dp_brand_primary_dullest = 'var(--dp_brand_primary_dullest)';
export const dp_brand_secondary_core = 'var(--dp_brand_secondary_core)';
export const dp_brand_secondary_brightest = 'var(--dp_brand_secondary_brightest)';
export const dp_brand_secondary_brighter = 'var(--dp_brand_secondary_brighter)';
export const dp_brand_secondary_bright = 'var(--dp_brand_secondary_bright)';
export const dp_brand_secondary_mid = 'var(--dp_brand_secondary_mid)';
export const dp_brand_secondary_dim = 'var(--dp_brand_secondary_dim)';
export const dp_brand_secondary_dull = 'var(--dp_brand_secondary_dull)';
export const dp_brand_secondary_duller = 'var(--dp_brand_secondary_duller)';
export const dp_brand_secondary_dullest = 'var(--dp_brand_secondary_dullest)';
export const dp_brand_tertiary_core = 'var(--dp_brand_tertiary_core)';
export const dp_brand_tertiary_brightest = 'var(--dp_brand_tertiary_brightest)';
export const dp_brand_tertiary_brighter = 'var(--dp_brand_tertiary_brighter)';
export const dp_brand_tertiary_bright = 'var(--dp_brand_tertiary_bright)';
export const dp_brand_tertiary_mid = 'var(--dp_brand_tertiary_mid)';
export const dp_brand_tertiary_dim = 'var(--dp_brand_tertiary_dim)';
export const dp_brand_tertiary_dull = 'var(--dp_brand_tertiary_dull)';
export const dp_brand_tertiary_duller = 'var(--dp_brand_tertiary_duller)';
export const dp_brand_tertiary_dullest = 'var(--dp_brand_tertiary_dullest)';
export const dp_brand_neutral_core = 'var(--dp_brand_neutral_core)';
export const dp_brand_neutral_brightest = 'var(--dp_brand_neutral_brightest)';
export const dp_brand_neutral_brighter = 'var(--dp_brand_neutral_brighter)';
export const dp_brand_neutral_bright = 'var(--dp_brand_neutral_bright)';
export const dp_brand_neutral_mid = 'var(--dp_brand_neutral_mid)';
export const dp_brand_neutral_dim = 'var(--dp_brand_neutral_dim)';
export const dp_brand_neutral_dull = 'var(--dp_brand_neutral_dull)';
export const dp_brand_neutral_duller = 'var(--dp_brand_neutral_duller)';
export const dp_brand_neutral_dullest = 'var(--dp_brand_neutral_dullest)';
export const dp_brand_white = 'var(--dp_brand_white)';
export const dp_brand_black = 'var(--dp_brand_black)';
export const dp_brand_negative_brightest = 'var(--dp_brand_negative_brightest)';
export const dp_brand_negative_brighter = 'var(--dp_brand_negative_brighter)';
export const dp_brand_negative_bright = 'var(--dp_brand_negative_bright)';
export const dp_brand_negative_mid = 'var(--dp_brand_negative_mid)';
export const dp_brand_negative_dull = 'var(--dp_brand_negative_dull)';
export const dp_brand_negative_duller = 'var(--dp_brand_negative_duller)';
export const dp_brand_negative_dullest = 'var(--dp_brand_negative_dullest)';
export const dp_brand_warning_brightest = 'var(--dp_brand_warning_brightest)';
export const dp_brand_warning_brighter = 'var(--dp_brand_warning_brighter)';
export const dp_brand_warning_bright = 'var(--dp_brand_warning_bright)';
export const dp_brand_warning_mid = 'var(--dp_brand_warning_mid)';
export const dp_brand_warning_dull = 'var(--dp_brand_warning_dull)';
export const dp_brand_warning_duller = 'var(--dp_brand_warning_duller)';
export const dp_brand_warning_dullest = 'var(--dp_brand_warning_dullest)';
export const dp_brand_info_brightest = 'var(--dp_brand_info_brightest)';
export const dp_brand_info_brighter = 'var(--dp_brand_info_brighter)';
export const dp_brand_info_bright = 'var(--dp_brand_info_bright)';
export const dp_brand_info_mid = 'var(--dp_brand_info_mid)';
export const dp_brand_info_dull = 'var(--dp_brand_info_dull)';
export const dp_brand_info_duller = 'var(--dp_brand_info_duller)';
export const dp_brand_info_dullest = 'var(--dp_brand_info_dullest)';
export const dp_brand_positive_brightest = 'var(--dp_brand_positive_brightest)';
export const dp_brand_positive_brighter = 'var(--dp_brand_positive_brighter)';
export const dp_brand_positive_bright = 'var(--dp_brand_positive_bright)';
export const dp_brand_positive_mid = 'var(--dp_brand_positive_mid)';
export const dp_brand_positive_dull = 'var(--dp_brand_positive_dull)';
export const dp_brand_positive_duller = 'var(--dp_brand_positive_duller)';
export const dp_brand_positive_dullest = 'var(--dp_brand_positive_dullest)';
export const dp_comp_button_primary_background = 'var(--dp_comp_button_primary_background)';
export const dp_comp_button_primary_background_hover =
  'var(--dp_comp_button_primary_background_hover)';
export const dp_comp_button_primary_background_pressed =
  'var(--dp_comp_button_primary_background_pressed)';
export const dp_comp_button_secondary_background = 'var(--dp_comp_button_secondary_background)';
export const dp_comp_button_secondary_background_hover =
  'var(--dp_comp_button_secondary_background_hover)';
export const dp_comp_button_secondary_background_pressed =
  'var(--dp_comp_button_secondary_background_pressed)';
export const dp_comp_button_tertiary_background = 'var(--dp_comp_button_tertiary_background)';
export const dp_comp_button_tertiary_background_hover =
  'var(--dp_comp_button_tertiary_background_hover)';
export const dp_comp_button_tertiary_background_pressed =
  'var(--dp_comp_button_tertiary_background_pressed)';
export const dp_comp_table_row = 'var(--dp_comp_table_row)';
export const dp_comp_table_row_hover = 'var(--dp_comp_table_row_hover)';
export const dp_comp_table_row_active_border = 'var(--dp_comp_table_row_active_border)';
export const dp_comp_skeleton_background_base = 'var(--dp_comp_skeleton_background_base)';
export const dp_comp_skeleton_background_duller = 'var(--dp_comp_skeleton_background_duller)';
export const dp_comp_message_negative_background = 'var(--dp_comp_message_negative_background)';
export const dp_comp_message_negative_left_edge = 'var(--dp_comp_message_negative_left_edge)';
export const dp_comp_message_negative_border = 'var(--dp_comp_message_negative_border)';
export const dp_comp_message_warning_background = 'var(--dp_comp_message_warning_background)';
export const dp_comp_message_warning_left_edge = 'var(--dp_comp_message_warning_left_edge)';
export const dp_comp_message_warning_border = 'var(--dp_comp_message_warning_border)';
export const dp_comp_message_info_background = 'var(--dp_comp_message_info_background)';
export const dp_comp_message_info_left_edge = 'var(--dp_comp_message_info_left_edge)';
export const dp_comp_message_info_border = 'var(--dp_comp_message_info_border)';
export const dp_comp_message_positive_background = 'var(--dp_comp_message_positive_background)';
export const dp_comp_message_positive_left_edge = 'var(--dp_comp_message_positive_left_edge)';
export const dp_comp_message_positive_border = 'var(--dp_comp_message_positive_border)';
export const dp_comp_input_border = 'var(--dp_comp_input_border)';
export const dp_comp_input_border_hover = 'var(--dp_comp_input_border_hover)';
export const dp_comp_input_border_focus = 'var(--dp_comp_input_border_focus)';
export const dp_comp_input_invalid_border = 'var(--dp_comp_input_invalid_border)';
export const dp_comp_input_invalid_border_hover = 'var(--dp_comp_input_invalid_border_hover)';
export const dp_comp_input_invalid_border_focus = 'var(--dp_comp_input_invalid_border_focus)';
export const dp_comp_input_placeholder_text = 'var(--dp_comp_input_placeholder_text)';
export const dp_comp_carrier_logo_monochrome_fill = 'var(--dp_comp_carrier_logo_monochrome_fill)';
export const dp_comp_focus_ring = 'var(--dp_comp_focus_ring)';
export const dp_comp_box_shadow = 'var(--dp_comp_box_shadow)';
export const dp_comp_input_binary_background_base = 'var(--dp_comp_input_binary_background_base)';
export const dp_comp_input_binary_background_hover = 'var(--dp_comp_input_binary_background_hover)';
export const dp_comp_input_binary_background_pressed =
  'var(--dp_comp_input_binary_background_pressed)';
export const dp_comp_input_binary_border_base = 'var(--dp_comp_input_binary_border_base)';
export const dp_comp_input_binary_border_hover = 'var(--dp_comp_input_binary_border_hover)';
export const dp_comp_input_binary_border_pressed = 'var(--dp_comp_input_binary_border_pressed)';
export const dp_comp_input_binary_selected_background_base =
  'var(--dp_comp_input_binary_selected_background_base)';
export const dp_comp_input_binary_selected_background_hover =
  'var(--dp_comp_input_binary_selected_background_hover)';
export const dp_comp_input_binary_selected_background_pressed =
  'var(--dp_comp_input_binary_selected_background_pressed)';
export const dp_comp_input_binary_selected_border_base =
  'var(--dp_comp_input_binary_selected_border_base)';
export const dp_comp_journey_search_form_bg = 'var(--dp_comp_journey_search_form_bg)';
export const dp_comp_quick_buy_button_bg = 'var(--dp_comp_quick_buy_button_bg)';
export const dp_comp_journey_summary_header_bg = 'var(--dp_comp_journey_summary_header_bg)';
export const dp_comp_swap_stations = 'var(--dp_comp_swap_stations)';
export const dp_comp_time_picker_disabled = 'var(--dp_comp_time_picker_disabled)';
export const dp_comp_eu_trip_header_bg = 'var(--dp_comp_eu_trip_header_bg)';
export const dp_comp_confirmation_header_bg = 'var(--dp_comp_confirmation_header_bg)';
export const dp_comp_basic_header_bg = 'var(--dp_comp_basic_header_bg)';
